// extracted by mini-css-extract-plugin
module.exports = {"header":"sessionMenu_header_1L5SICY","label":"sessionMenu_label_3CAtNSu","manageButton":"sessionMenu_manageButton_3DS4onA","divider":"sessionMenu_divider_1yupIQj"};